var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"bc-my-projects-intro"},[_c(_setup.IconMyProjects),_c('h1',{staticClass:"c-title"},[_vm._v(" "+_vm._s(_setup.t('my-projects.title'))+" ")]),[_c(_setup.BCXMarkdown,{staticClass:"c-intro",attrs:{"unstyled":"","text":_setup.introMessage}})]],2)
}
var staticRenderFns = []

export { render, staticRenderFns }